import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { auth } from './firebase';
import Home from "./pages/Home";
import Navbar from './components/Navbar';
import About from './pages/About';
import Footer from './components/Footer';
import Tracking from './pages/Tracking';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Cargo from './admin/Cargo';
import Login from './admin/Login';
import Users from './admin/Users';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  const isAuthenticated = () => {
    return user !== null;
  };
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
        <Route
            path="/admin"
            element={isAuthenticated() ? <Cargo /> : <Navigate to="/login" />}
          />
          <Route path="/users" element={<Users />} />
          <Route path="/login" element={<Login />} />
          <Route
          path='/'
          element={<Home />} />
          <Route
          path='/about'
          element={<About />} />
          <Route
          path='/tracking'
          element={<Tracking />} />
          <Route
          path='/services'
          element={<Services />} />
          <Route
          path='/contact'
          element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
